//changed due to package upgrade
import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import IntlMessages from '@projectK/helpers/IntlMessages';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AppGridContainer from '@projectK/components/AppGridContainer';
import {
  alpha,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useMediaQuery,
} from '@mui/material';
import { Field, Form, Formik } from 'formik';
import jwtAxios from '@projectK/services/auth/JWT';
import { CloseRounded } from '@mui/icons-material';
import AppTextField from '@projectK/components/AppTextField';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import EditIcon from '@mui/icons-material/Edit';
import { useInfoViewActionsContext } from '@projectK/context';
import PropTypes from 'prop-types';
import AppModalConfirmation from '@projectK/components/AppModalConfirmation';

const EditAttendance = ({
  isOpen,
  onClose,
  activitySessionData,
  reportFields,
  attendanceData,
  sessionId,
  studentId,
  reportName,
  fetchAttendanceData,
  handleReportsData,
}) => {
  const isSmallDevice = useMediaQuery('(max-width:600px)');
  const companyTheme = CompanyTheme();
  const infoViewActionsContext = useInfoViewActionsContext();
  const [openDialog, setOpenDialog] = useState(false);
  const formatStartDateTimeRange = (startDate, startTime) => {
    const formattedStartDate = new Date(
      `${startDate?.substring(0, 10)}T12:01:00`,
    ).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });

    const formattedStartTime = new Date(
      `1970-01-01T${startTime}`,
    ).toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });

    return (
      <div>
        {formattedStartDate}&nbsp;&nbsp;&nbsp;
        {formattedStartTime}
      </div>
    );
  };
  const formatEndDateTimeRange = (endDate, endTime) => {
    const formattedEndDate = new Date(
      `${endDate?.substring(0, 10)}T12:01:00`,
    ).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });

    const formattedEndTime = new Date(`1970-01-01T${endTime}`).toLocaleString(
      'en-US',
      {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      },
    );

    return (
      <div>
        {formattedEndDate}&nbsp;&nbsp;&nbsp;
        {formattedEndTime}
      </div>
    );
  };
  const [isEdit, setIsEdit] = useState(true);
  const handleEditClick = () => {
    setIsEdit(true);
  };

  const [reportFieldsData, setReportFieldsData] = useState([]);
  const [feedbackData, setFeedbackData] = useState([]);
  useEffect(() => {
    fetchReportFieldsData();
  }, []);

  const fetchReportFieldsData = async () => {
    try {
      const response = await jwtAxios.get(
        `/user-reports-data/user/${activitySessionData.id}`,
        {
          params: {
            user_id: attendanceData.user_id,
          },
        },
      );
      const { data } = response;
      setReportFieldsData(data.list);
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };
  useEffect(() => {
    fetchFeedbackData();
  }, []);

  const fetchFeedbackData = async () => {
    try {
      const response = await jwtAxios.get(
        `/user-feedback/user/${activitySessionData.id}`,
        {
          params: {
            user_id: attendanceData.user_id,
          },
        },
      );
      const { data } = response;
      setFeedbackData(data.list);
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const parsedEntryDate = new Date(attendanceData?.attendance_date);
  parsedEntryDate.setDate(parsedEntryDate.getDate() + 1);
  const formattedEntryDate = parsedEntryDate.toISOString().split('T')[0];

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleCloseModalDialog = () => {
    setOpenDialog(false); // to close the dialog
    handleModalClose(); //to close the modal
  };
  const handleModalClose = () => {
    onClose();
  };
  return (
    <>
      <Modal open={isOpen} onClose={handleDialogOpen}>
        <Box
          className='p-popup'
          sx={{
            bgcolor: 'background.paper',
          }}
        >
          <Formik
            enableReinitialize={true}
            initialValues={{
              fields:
                reportFieldsData[reportName]?.map((element) => ({
                  report_field_name: element.report_field_name,
                  report_field_id: element.report_field_id,
                  value: element.value === '' ? null : element.value,
                  user_report_data_id: element.user_report_data_id,
                })) || [],
              user_id: attendanceData?.user_id || '',
              is_attended: attendanceData?.is_attended || false,
              attendance_id: attendanceData?.id || false,
              attendance_date: formattedEntryDate || '',
              activity_session_id: parseInt(sessionId),
              report_id: attendanceData?.reportId || '',
              activity_id: attendanceData?.activityId || '',
              feedback: feedbackData.feedback || '',
              feedback_id: feedbackData.id || '',
            }}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                const {
                  fields,
                  feedback,
                  feedback_id,
                  is_attended,
                  attendance_id,
                } = values;
                const requestData = {
                  is_attended: is_attended,
                };

                // Promises array to handle multiple asynchronous requests
                const promises = [];

                // Add feedback if it exists
                const feedbackdata = {
                  feedback: feedback,
                };
                promises.push(
                  jwtAxios.put(`/user-feedback/${feedback_id}`, feedbackdata),
                );

                // Add attendance
                promises.push(
                  jwtAxios.put(`/attendance/${attendance_id}`, requestData),
                );

                // Check if there are fields with data and attendance is marked

                fields.forEach((field) => {
                  promises.push(
                    jwtAxios.put(
                      `/user-reports-data/${field.user_report_data_id}`,
                      {
                        value: field.value || '',
                      },
                    ),
                  );
                });

                // Execute all promises concurrently
                await Promise.all(promises);

                fetchAttendanceData();
                fetchFeedbackData();
                fetchReportFieldsData();
                handleReportsData();
                // Show success message
                infoViewActionsContext.showMessage(
                  'Attendance Updated successfully!',
                );
                onClose();
                // Close modal
              } catch (error) {
                // Handle errors
                infoViewActionsContext.fetchError(error.response.data.error);
              } finally {
                // Set submitting to false
                setSubmitting(false);
              }
            }}
          >
            {({ resetForm, setFieldValue, values }) => (// NOSONAR
              <Form noValidate autoComplete='off' className='main'>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Box>
                    <Typography
                      variant='h4'
                      style={{
                        marginTop: '10px',
                        color: companyTheme
                          ? companyTheme.primary.main
                          : 'text.primary',
                      }}
                    >
                      View Attendance
                    </Typography>
                  </Box>
                  <Box>
                    <IconButton
                      size='small'
                      sx={{ fontWeight: 'bold', color: '#000000' }}
                      className='icon-btn'
                      onClick={handleDialogOpen}
                    >
                      <CloseRounded />
                    </IconButton>
                  </Box>
                </Box>
                <AppGridContainer sx={{ mt: 2 }}>
                  <Grid size={{ xs: 12, md: 12 }}>
                    <Box
                      sx={{
                        border: '1px solid #EAECF0',
                        p: 6,
                        borderRadius: 3,
                        boxShadow:
                          '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
                      }}
                    >
                      <AppGridContainer>
                        <Grid size={{ xs: 12, md: 12 }}>
                          <Grid container spacing={2}>
                            <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='left'>
                                  <span>Activity Name</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='center'>
                                  <span>:</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                              {' '}
                              <Typography
                                variant='h4'
                                sx={{ fontWeight: 'normal' }}
                              >
                                <Box display='flex' justifyContent='flex-start'>
                                  <span className='wordbreak'>
                                    {activitySessionData.activity_name}
                                  </span>
                                </Box>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='left'>
                                  <span>Activity Display Name</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='center'>
                                  <span>:</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                              {' '}
                              <Typography
                                variant='h4'
                                sx={{ fontWeight: 'normal' }}
                              >
                                <Box display='flex' justifyContent='flex-start'>
                                  <span className='wordbreak'>
                                    {activitySessionData?.activity_display_name}
                                  </span>
                                </Box>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='left'>
                                  <span>Start Date/Time</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='center'>
                                  <span>:</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                              {' '}
                              <Typography
                                variant='h4'
                                sx={{ fontWeight: 'normal' }}
                              >
                                <Box display='flex' justifyContent='flex-start'>
                                  <span>
                                    {formatStartDateTimeRange(
                                      activitySessionData?.start_date,
                                      activitySessionData?.start_time,
                                    )}
                                  </span>
                                </Box>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='left'>
                                  <span>End Date/Time</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='center'>
                                  <span>:</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                              {' '}
                              <Typography
                                variant='h4'
                                sx={{ fontWeight: 'normal' }}
                              >
                                <Box display='flex' justifyContent='flex-start'>
                                  <span>
                                    {formatEndDateTimeRange(
                                      activitySessionData?.end_date,
                                      activitySessionData?.end_time,
                                    )}
                                  </span>
                                </Box>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='left'>
                                  <span>Facility Location</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='center'>
                                  <span>:</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                              {' '}
                              <Typography
                                variant='h4'
                                sx={{ fontWeight: 'normal' }}
                              >
                                <Box display='flex' justifyContent='flex-start'>
                                  <span className='wordbreak'>
                                    {activitySessionData.location_name}
                                  </span>
                                </Box>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='left'>
                                  <span>Entry Date</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='center'>
                                  <span>:</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                              {' '}
                              <Typography
                                variant='h4'
                                sx={{ fontWeight: 'normal' }}
                              >
                                <Box display='flex' justifyContent='flex-start'>
                                  <span>
                                    {new Date(
                                      `${attendanceData.created_at.substring(
                                        0,
                                        10,
                                      )}T12:01:00`,
                                    ).toLocaleDateString('en-US', {
                                      year: 'numeric',
                                      month: 'short',
                                      day: 'numeric',
                                    })}
                                  </span>
                                </Box>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='left'>
                                  <span>Attented Date</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                              <Typography variant='h4'>
                                <Box display='flex' justifyContent='center'>
                                  <span>:</span>
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                              {' '}
                              <Typography
                                variant='h4'
                                sx={{ fontWeight: 'normal' }}
                              >
                                <Box display='flex' justifyContent='flex-start'>
                                  <span>
                                    {new Date(
                                      `${attendanceData?.attendance_date?.substring(
                                        0,
                                        10,
                                      )}T12:01:00`,
                                    ).toLocaleDateString('en-US', {
                                      year: 'numeric',
                                      month: 'short',
                                      day: 'numeric',
                                    })}
                                  </span>
                                </Box>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </AppGridContainer>
                      <Divider sx={{ my: 4 }} />
                      <AppGridContainer>
                        <Grid size={{ xs: 12, md: 12 }}>
                          <Table
                            style={{
                              display: isSmallDevice ? 'none' : 'table',
                            }}
                          >
                            <TableHead>
                              <TableCell>Name</TableCell>
                              <TableCell>
                                {reportFields[0]?.report_name}
                              </TableCell>

                              <Box></Box>
                            </TableHead>
                            <TableBody>
                              <TableCell>
                                {attendanceData.firstName}{' '}
                                {attendanceData.lastName}
                              </TableCell>
                              <TableCell>
                                <Grid size={{ xs: 12, md: 12 }}>
                                  <FormControlLabel
                                    control={
                                      <Field
                                        component={Checkbox}
                                        type='checkbox'
                                        name='is_attended'
                                        id='is_attended'
                                        checked={values.is_attended}
                                        onChange={
                                          isEdit
                                            ? (e) =>
                                                setFieldValue(
                                                  'is_attended',
                                                  e.target.checked,
                                                )
                                            : null
                                        }
                                      />
                                    }
                                  />
                                </Grid>
                              </TableCell>
                              <TableCell>
                                <Grid container spacing={2}>
                                  {reportFieldsData[reportName]
                                    ? values?.fields?.map((field, index) => {
                                        const isDisabled = false;

                                        return (
                                          <Grid
                                            size={{ xs: 12, md: 4 }}
                                            key={field.report_field_name}
                                          >
                                            <AppTextField
                                              name={`fields[${index}].value`}
                                              value={field.value}
                                              onChange={
                                                isEdit
                                                  ? (e) => {
                                                      setFieldValue(
                                                        `fields[${index}].value`,
                                                        e.target.value,
                                                      );
                                                    }
                                                  : null
                                              }
                                              variant='outlined'
                                              sx={{
                                                width: '100%',
                                                marginBottom: '10px',
                                              }}
                                              label={field.report_field_name}
                                              disabled={isDisabled}
                                            />
                                            <input
                                              type='hidden'
                                              name={`fields[${index}].report_field_id`}
                                              value={field.report_field_id}
                                            />
                                          </Grid>
                                        );
                                      })
                                    : reportFields.map((field, index) => (
                                        <Grid
                                          size={{ xs: 12, md: 4 }}
                                          key={field.report_field_name}
                                        >
                                          <AppTextField
                                            name={`fields[${index}].value`}
                                            value={field.value}
                                            onChange={
                                              isEdit
                                                ? (e) => {
                                                    setFieldValue(
                                                      `fields[${index}].value`,
                                                      e.target.value,
                                                    );
                                                  }
                                                : null
                                            }
                                            slotProps={{
                                              input: {
                                                readOnly: !isEdit,
                                              },
                                            }}
                                            variant='outlined'
                                            sx={{
                                              width: '100%',
                                              marginBottom: '10px',
                                            }}
                                            label={field.report_field_name}
                                          />
                                          <input
                                            type='hidden'
                                            name={`fields[${index}].report_field_id`}
                                            value={field.report_field_id}
                                          />
                                        </Grid>
                                      ))}
                                </Grid>
                                <Grid size={{ xs: 12, md: 12 }}>
                                  <AppTextField
                                    name='feedback'
                                    variant='outlined'
                                    label='Feedback'
                                    value={values.feedback}
                                    slotProps={{
                                      input: {
                                        readOnly: !isEdit,
                                      },
                                    }}
                                    onChange={
                                      isEdit
                                        ? (e) => {
                                            setFieldValue(
                                              'feedback',
                                              e.target.value,
                                            );
                                          }
                                        : null
                                    }
                                    fullWidth
                                  />
                                  <input
                                    type='hidden'
                                    name='feedback'
                                    value={values.feedback}
                                  />
                                </Grid>
                              </TableCell>
                            </TableBody>
                          </Table>
                          <Table
                            style={{
                              display: isSmallDevice ? 'table' : 'none',
                            }}
                          >
                            <TableBody>
                              <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell sx={{ textAlign: 'left' }}>
                                  <span className='wordbreak'>
                                    {attendanceData.firstName}{' '}
                                    {attendanceData.lastName}
                                  </span>
                                </TableCell>

                                <TableCell sx={{ width: '30px' }}>
                                  <Grid size={{ xs: 12, md: 12 }}>
                                    <FormControlLabel
                                      control={
                                        <Field
                                          component={Checkbox}
                                          type='checkbox'
                                          name='is_attended'
                                          id='is_attended'
                                          checked={values.is_attended}
                                          onChange={
                                            isEdit
                                              ? (e) =>
                                                  setFieldValue(
                                                    'is_attended',
                                                    e.target.checked,
                                                  )
                                              : null
                                          }
                                        />
                                      }
                                    />
                                  </Grid>
                                </TableCell>

                                <Box>
                                  {!isEdit && (
                                    <EditIcon
                                      sx={{ cursor: 'pointer' }}
                                      onClick={handleEditClick}
                                    />
                                  )}
                                </Box>
                              </TableRow>
                              <TableRow>
                                <TableCell
                                  colSpan={3}
                                  sx={{ borderBottom: 'none' }}
                                >
                                  {reportFields[0]?.report_name}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell
                                  colSpan={3}
                                  sx={{ borderBottom: 'none' }}
                                >
                                  <Grid container spacing={2}>
                                    {reportFieldsData[reportName]
                                      ? values?.fields?.map((field, index) => {
                                          const isDisabled = false;
                                          return (
                                            <Grid
                                              size={{ xs: 12, md: 4 }}
                                              key={field.report_field_name}
                                            >
                                              <AppTextField
                                                name={`fields[${index}].value`}
                                                value={field.value}
                                                onChange={
                                                  isEdit
                                                    ? (e) => {
                                                        setFieldValue(
                                                          `fields[${index}].value`,
                                                          e.target.value,
                                                        );
                                                      }
                                                    : null
                                                }
                                                variant='outlined'
                                                sx={{
                                                  width: '100%',
                                                  marginBottom: '10px',
                                                }}
                                                label={field.report_field_name}
                                                disabled={isDisabled}
                                              />
                                              <input
                                                type='hidden'
                                                name={`fields[${index}].report_field_id`}
                                                value={field.report_field_id}
                                              />
                                            </Grid>
                                          );
                                        })
                                      : reportFields.map((field, index) => (
                                          <Grid
                                            size={{ xs: 12, md: 4 }}
                                            key={field.report_field_name}
                                          >
                                            <AppTextField
                                              name={`fields[${index}].value`}
                                              value={field.value}
                                              onChange={
                                                isEdit
                                                  ? (e) => {
                                                      setFieldValue(
                                                        `fields[${index}].value`,
                                                        e.target.value,
                                                      );
                                                    }
                                                  : null
                                              }
                                              variant='outlined'
                                              sx={{
                                                width: '100%',
                                                marginBottom: '10px',
                                              }}
                                              slotProps={{
                                                input: {
                                                  readOnly: !isEdit,
                                                },
                                              }}
                                              label={field.report_field_name}
                                            />
                                            <input
                                              type='hidden'
                                              name={`fields[${index}].report_field_id`}
                                              value={field.report_field_id}
                                            />
                                          </Grid>
                                        ))}
                                  </Grid>
                                  <Grid size={{ xs: 12, md: 12 }}>
                                    <AppTextField
                                      name='feedback'
                                      variant='outlined'
                                      label='Feedback'
                                      value={values.feedback}
                                      onChange={
                                        isEdit
                                          ? (e) => {
                                              setFieldValue(
                                                'feedback',
                                                e.target.value,
                                              );
                                            }
                                          : null
                                      }
                                      slotProps={{
                                        input: {
                                          readOnly: !isEdit,
                                        },
                                      }}
                                      fullWidth
                                    />
                                    <input
                                      type='hidden'
                                      name='feedback'
                                      value={values.feedback}
                                    />
                                  </Grid>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Button
                              sx={{
                                position: 'relative',
                                minWidth: 100,
                                backgroundColor: companyTheme
                                  ? companyTheme.primary.main
                                  : '#2196f3',
                                '&:hover': {
                                  backgroundColor: companyTheme
                                    ? alpha(companyTheme.primary.main, 0.8) // Adjust the alpha value as needed
                                    : alpha('#2196f3', 0.8),
                                },
                              }}
                              color='primary'
                              variant='contained'
                              type='submit'
                            >
                              <IntlMessages id='common.saveChanges' />
                            </Button>
                            <Button
                              sx={{
                                position: 'relative',
                                minWidth: 100,
                                ml: 2.5,
                                borderColor: companyTheme
                                  ? companyTheme.primary.main
                                  : '#2196f3',
                                '&:hover': {
                                  borderColor: companyTheme
                                    ? alpha(companyTheme.primary.main, 0.8)
                                    : alpha('#2196f3', 0.8),
                                },
                                color: companyTheme
                                  ? companyTheme.primary.main
                                  : '#2196f3',
                              }}
                              variant='outlined'
                              onClick={handleDialogOpen}
                            >
                              <IntlMessages id='common.cancel' />
                            </Button>
                          </Box>
                        </Grid>
                      </AppGridContainer>
                    </Box>
                  </Grid>
                </AppGridContainer>
              </Form>
            )}
          </Formik>
        </Box>
      </Modal>
      <AppModalConfirmation
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        handleCloseModalDialog={handleCloseModalDialog}
      />
    </>
  );
};

export default EditAttendance;
EditAttendance.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  activitySessionData: PropTypes.object,
  reportFields: PropTypes.array,
  attendanceData: PropTypes.object,
  sessionId: PropTypes.string,
  studentId: PropTypes.number,
  reportName: PropTypes.string,
  fetchAttendanceData: PropTypes.func,
  handleReportsData: PropTypes.func,
};
